<template>
  <nav
    class="app-pagination"
    role="navigation"
    :aria-label="ariaLabel"
  >
    <div class="pagination-flex-row">
      <button
        class="pagination-previous app-paginator-btn"
        :disabled="currentPage <= 1"
        aria-label="Previous page"
        @click="$emit('update:currentPage', currentPage - 1)"
      >
        <i
          class="fas fa-chevron-left mr-1"
          aria-hidden="true"
        />
        <slot name="prev">
          Prev
        </slot>
      </button>
      <ul class="pagination-list">
        <template v-if="!isMobile">
          <li
            v-for="n in visiblePages"
            :key="n"
          >
            <span
              v-if="n === '...'"
              class="pagination-ellipsis"
            >&hellip;</span>
            <button
              v-else
              class="pagination-link app-paginator-btn"
              :class="{ 'is-current': n === currentPage }"
              :aria-label="n === currentPage ? 'Current page' : 'Go to page ' + n"
              :disabled="n === currentPage"
              @click="$emit('update:currentPage', n)"
            >
              {{ n }}
            </button>
          </li>
        </template>
        <template v-else>
          <li>
            <button
              class="pagination-link app-paginator-btn is-current"
              :aria-label="'Current page'"
              disabled
            >
              {{ currentPage }}
            </button>
          </li>
        </template>
      </ul>
      <button
        class="pagination-next app-paginator-btn"
        :disabled="currentPage >= totalPages"
        aria-label="Next page"
        @click="$emit('update:currentPage', currentPage + 1)"
      >
        <slot name="next">
          Next
        </slot>
        <i
          class="fas fa-chevron-right ml-1"
          aria-hidden="true"
        />
      </button>
    </div>
  </nav>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
const props = defineProps({
  currentPage: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  maxPagesAround: { type: Number, default: 4 },
  ariaLabel: { type: String, default: 'Pagination' },
});

const isMobile = ref(false);
function checkMobile() { isMobile.value = window.innerWidth <= 600; }
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const visiblePages = computed(() => {
  const p = props.currentPage;
  const t = props.totalPages;
  const m = props.maxPagesAround;
  const range = [];
  const start = Math.max(1, p - m);
  const end = Math.min(t, p + m);
  if (start > 1) range.push(1);
  if (start > 2) range.push('...');
  for (let i = start; i <= end; i++) range.push(i);
  if (end < t - 1) range.push('...');
  if (end < t) range.push(t);
  return range;
});
</script>